import script from "./diy.vue?vue&type=script&setup=true&lang=js"
export * from "./diy.vue?vue&type=script&setup=true&lang=js"

import "./diy.vue?vue&type=style&index=0&id=1c75bbf6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c75bbf6"]])

export default __exports__